import { getInventoryByProductVersionId, inventoryByProductVersionFromFirestore } from '@parallel-fluidics/shared/models/inventory';
import { doc, getFirestore } from 'firebase/firestore';
import useRealtimeDoc from 'hooks/use-realtimeDoc';
import { useMemo } from 'react';

export default function useRealtimeInventoryByProductVersion(productDocId, versionId) {
  const docRef = useMemo(() => {
    if (!productDocId || !versionId) return null;
    return doc(
      getFirestore(),
      'inventoryByProductVersion',
      getInventoryByProductVersionId(productDocId, versionId),
    );
  }, [productDocId, versionId]);

  return useRealtimeDoc({
    docRef,
    transformData: inventoryByProductVersionFromFirestore,
  });
}
